import logo from "./logo.svg";
import "./App.css";
import Patient from "./components/patient/patient";
import Milestones from "./components/milestones/milestones";
import Room from "./components/room/room";
import Footer from "./components/footer/footer";

function App() {
  return (
    <div className="App-header">
      <div className="pb-20 flex flex-col items-center">
        <img
          className="p-1 w-40 h-40 rounded-full ring-2 ring-gray-300 dark:ring-gray-500"
          src="https://i.postimg.cc/mkNSVNmN/saja.jpg"
          alt="Bordered avatar"
        ></img>
        <h1 className="text-6xl font-bold pt-6">Saja</h1>
      </div>
      <div>
        <h1 className="font-bold text-5xl mt-12 mb-8">🐣 My Caretakers</h1>
        <Patient />
        <Milestones />
        <Room />
        <Footer />
      </div>
    </div>
  );
}

export default App;
